module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av169-0cc5e77f9cbaaf2c2a2e99d638e13d37.jpg";